"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralSchema = exports.RecipientSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
const referral_1 = require("../enums/referral");
exports.RecipientSchema = zod_1.z.object({
    email: __1.ShortStringSchema.email(),
    name: __1.ShortStringSchema.optional(),
    status: zod_1.z.nativeEnum(referral_1.ReferralRecipientStatus).optional(),
    signedUpUserId: __1.ShortStringSchema.optional(),
    signedUpStoreId: __1.ShortStringSchema.optional(),
});
exports.ReferralSchema = __1.BaseSchema.extend({
    comment: __1.MediumStringSchema,
    recipients: exports.RecipientSchema.array(),
    store: __1.StoreSchema.partial().required({ id: true }),
});
//# sourceMappingURL=index.js.map